/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1BookbindingbindersQueryResponse } from '../../types/GetV1Bookbindingbinders.ts'

export const getV1BookbindingbindersQueryKey = () => [{ url: '/v1/BookBindingBinders' }] as const

export type GetV1BookbindingbindersQueryKey = ReturnType<typeof getV1BookbindingbindersQueryKey>

/**
 * {@link /v1/BookBindingBinders}
 */
export async function getV1Bookbindingbinders(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1BookbindingbindersQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/BookBindingBinders`, ...requestConfig })
    return res
}

export function getV1BookbindingbindersQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1BookbindingbindersQueryKey()
    return queryOptions<
        ResponseConfig<GetV1BookbindingbindersQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1BookbindingbindersQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Bookbindingbinders(config)
        },
    })
}

/**
 * {@link /v1/BookBindingBinders}
 */
export function useGetV1Bookbindingbinders<
    TData = ResponseConfig<GetV1BookbindingbindersQueryResponse>,
    TQueryData = ResponseConfig<GetV1BookbindingbindersQueryResponse>,
    TQueryKey extends QueryKey = GetV1BookbindingbindersQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1BookbindingbindersQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1BookbindingbindersQueryKey()

    const query = useQuery(
        {
            ...getV1BookbindingbindersQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
